/**
 * Portal Manta · TourPanelM
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { TOUR_M, NUM_BY_ID } from '../../data/capitulos.js';

const TourPanelM = memo(function TourPanelM_Inner({tourStep, setTourStep, scrollTo}){
  const passo = TOUR_M[tourStep];
  const total = TOUR_M.length;
  if (!passo) return null;

  const goTo = (i) => {
    setTourStep(i);
    if (scrollTo) scrollTo(TOUR_M[i].id);
  };
  const next = () => { if (tourStep < total - 1) goTo(tourStep + 1); };
  const prev = () => { if (tourStep > 0) goTo(tourStep - 1); };

  return (<aside style={{
    width:280, flexShrink:0, position:'sticky', top:0, alignSelf:'flex-start',
    height:'100vh', overflowY:'auto', borderLeft:`1px solid ${M.border}`,
    padding:'24px 18px', background:M.bg, fontFamily:F.body,
  }}>
    {/* Header tour */}
    <div style={{fontFamily:F.mono, fontSize:9, letterSpacing:3, color:M.accent, marginBottom:6, textTransform:'uppercase'}}>
      Manta · Tour Interativo
    </div>
    <div style={{fontSize:11, color:M.muted, marginBottom:14}}>
      Padrão 12.5 · {total} passos
    </div>

    {/* Passo atual */}
    <div style={{display:'flex', alignItems:'baseline', gap:8, marginBottom:6}}>
      {NUM_BY_ID[passo.id] && (
        <span style={{fontFamily:F.mono, fontSize:10, color:'#fff', fontWeight:700, padding:'2px 7px', background:M.accent, letterSpacing:.8, flexShrink:0}}>
          {NUM_BY_ID[passo.id]}
        </span>
      )}
      <div style={{fontSize:9.5, color:M.muted, fontFamily:F.mono, letterSpacing:1, textTransform:'uppercase'}}>
        Cap {passo.cap}
      </div>
    </div>
    <div style={{fontFamily:F.display, fontWeight:700, fontSize:15, color:M.heading, lineHeight:1.3, marginBottom:14}}>
      {passo.n}. {passo.titulo}
    </div>

    {/* Mostra */}
    <div style={{marginBottom:12, padding:'10px 12px', background:M.bgAlt, borderLeft:`3px solid ${M.accent}`}}>
      <div style={{fontSize:9, color:M.accent, fontWeight:700, letterSpacing:1, textTransform:'uppercase', marginBottom:4}}>O que mostra</div>
      <div style={{fontSize:11.5, color:M.text, lineHeight:1.5}}>{passo.mostra}</div>
    </div>

    {/* Por que */}
    <div style={{marginBottom:18, padding:'10px 12px', background:M.bgAlt, borderLeft:`3px solid ${M.title}`}}>
      <div style={{fontSize:9, color:M.title, fontWeight:700, letterSpacing:1, textTransform:'uppercase', marginBottom:4}}>Por que olhar</div>
      <div style={{fontSize:11.5, color:M.text, lineHeight:1.5}}>{passo.porQue}</div>
    </div>

    {/* Controles */}
    <div style={{display:'flex', gap:6, marginBottom:14}}>
      <button onClick={prev} disabled={tourStep===0} style={{flex:1, padding:'7px 10px', fontSize:10.5, fontWeight:700, border:`1px solid ${M.border}`, background:tourStep===0?M.borderSoft:'#fff', color:tourStep===0?M.light:M.text, cursor:tourStep===0?'default':'pointer', fontFamily:F.body}}>← Anterior</button>
      <button onClick={next} disabled={tourStep===total-1} style={{flex:1, padding:'7px 10px', fontSize:10.5, fontWeight:700, border:'none', background:tourStep===total-1?M.borderSoft:M.accent, color:tourStep===total-1?M.light:'#fff', cursor:tourStep===total-1?'default':'pointer', fontFamily:F.body}}>Próximo →</button>
    </div>

    {/* Lista completa (clicar pula) */}
    <div style={{borderTop:`1px solid ${M.border}`, paddingTop:12}}>
      <div style={{fontSize:9, color:M.muted, fontWeight:700, letterSpacing:1, textTransform:'uppercase', marginBottom:8}}>Sequência completa</div>
      {TOUR_M.map((p, i) => {
        const ativo = i === tourStep;
        return (
          <div key={p.id} onClick={()=>goTo(i)} style={{
            display:'flex', alignItems:'center', gap:8, padding:'5px 8px', marginBottom:2,
            background: ativo?M.bgAlt:'transparent', borderLeft:`3px solid ${ativo?M.accent:'transparent'}`,
            cursor:'pointer', borderRadius:'0 3px 3px 0', transition:'all .12s',
          }}>
            <span style={{fontFamily:F.mono, fontSize:9, color:ativo?M.accent:M.muted, fontWeight:700, flexShrink:0, minWidth:30}}>
              {NUM_BY_ID[p.id]}
            </span>
            <span style={{fontSize:10.5, color:ativo?M.heading:M.muted, fontWeight:ativo?700:500, lineHeight:1.3}}>{p.titulo}</span>
          </div>
        );
      })}
    </div>
  </aside>);
});

export { TourPanelM };
export default TourPanelM;
